module.exports = __webpack_public_path__ + "img/fav.7f2572ea.png";